// src/features/chat/components/his/HisDateDivider.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { format, isToday, isYesterday } from 'date-fns';
import styles from './HisDateDivider.module.css';

/**
 * Date divider — the only structural punctuation in the HIS timeline.
 */
export function HisDateDivider({ dateMs }) {
  const { t } = useTranslation();
  if (!dateMs) return null;
  const date = new Date(dateMs);
  const label = isToday(date)
    ? t('chat.today')
    : isYesterday(date)
      ? t('chat.yesterday')
      : format(date, 'MMMM d');
  return (
    <div className={styles.divider}>
      <span>{label}</span>
    </div>
  );
}

export default HisDateDivider;
